<template>
  <div class="propagandas">
    <el-row class="data-total">
      <el-col
        class="total-item"
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
      >
        <div class="label">{{$t('Customet_Equity')}} ({{currency}})</div>
        <div class="data">{{ statistics.subEquity }} </div>
      </el-col>
      <el-col
        class="total-item"
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
      >
        <div class="label">{{$t('clientBanlance')}} ({{currency}})</div>
        <div class="data">{{ statistics.subBalance }} </div>
      </el-col>
      <el-col
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
        class="total-item">
        <div class="label">{{$t('Home.forexVolume')}} (Lots)</div>
        <div class="data">{{ statistics.subLots }}</div>
      </el-col>
      <el-col
        :lg="6"
        :md="6"
        :sm="12"
        :xs="12"
        class="total-item"
      >
        <div class="label">{{$t('Commission_is_available')}} ({{currency}})</div>
        <div class="data special-data">
          <span class="outer-left-btn">{{ statistics.remainAmount }} </span>
          <el-button
            :disabled="outBtnDisable"
            type="primary"
            size="small"
            @click="outHandle"
          >{{$t('Commission')}}</el-button>
        </div>
      </el-col>
    </el-row>
    <div class="my-rule">
      <div class="header">
        <div class="title">{{$t('My_rebate_rules')}}</div>
      </div>
      <div class="content RuleTable-outer rule-table-outer">
        <RuleTable
          :isReadonly="true"
          :ruleData="partner.ruleList"
          ref="ruletable"
        />
      </div>
    </div>
    <div class="customer-link">
      <div class="link-group">
        <div class="group-title">
          {{$t('Direct_link')}}
        </div>
        <div
          v-for="(item,index) in guestInvitationLinks"
          :key="index"
          class="bg-box">
          <div class="link-title">{{$t('direct_link')}}</div>
          <div class="link-content">
            <div class="left-content">
              <div class="link-text-wrapper pointer"  @click="copyHandle(item.linkForCust)">
                <el-tooltip :content="item.linkForCust" placement="top" :max-width="400">
                  <div class="link-text">{{item.linkForCust}}</div>
                </el-tooltip>
                <el-button type="primary" size="small" class="copy-button">{{$t('copy_link')}}</el-button>
              </div>
              <div class="invite-code-wrapper">
                <span class="invite-code pointer" @click="copyHandle(item.invitationCode)">
                  {{$t('invite_code')}}: {{item.invitationCode }}
                  <el-tooltip :content="$t('copy_content_to_clipboard')" placement="top">
                    <i class="iconfont icon-copy1 pointer"></i>
                  </el-tooltip>
                </span>
                <div class="qr-code-container pointer" @click="openQrCodeDialog(item.qrForCust)">
                  <el-tooltip :content="$t('view_qr_code')" placement="top">
                    <qr-code-icon></qr-code-icon>
                  </el-tooltip>
                  <el-button type="text" class="view-qr-button">{{$t('view_qr_code')}}</el-button>
                </div>
              </div>
            </div>
            <div class="icon-right">
              <div class="icon-wrapper pointer" @click="lookDirectRuleInfoHandle(item)">
                <el-tooltip :content="$t('view_rebate_rules')" placement="top">
                  <eye-icon></eye-icon>
                </el-tooltip>
              </div>
              <div class="icon-wrapper pointer" v-if="item.linkList && item.linkList.length > 0" @click="openEditLinksDialog(item, 'guest')">
                <el-tooltip :content="$t('more_links')" placement="top">
                  <more-icon></more-icon>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="userInfo.hierarchy >= 2"
        class="link-group">
        <div class="subib-group-title">
          <span class="group-title">{{$t('Sub_IB_link')}}</span>
          <el-button
            v-if="userInfo.addLevelFlag"
            type="primary"
            @click="addSubLinkHandle"
            size="small"
          >{{$t('Add_a_link')}}</el-button>
        </div>
        <div class="link-item"
             v-for="(item,index) in subIbInfoList"
             :key="index"
        >
          <div class="bg-box">
            <div class="link-title">{{item.levelName}}</div>
            <div class="link-content">
              <div class="left-content">
                <div class="link-text-wrapper pointer" @click="copyHandle(item.link)">
                  <el-tooltip :content="item.link" placement="top" :max-width="400">
                    <div class="link-text">{{item.link}}</div>
                  </el-tooltip>
                  <el-button type="primary" size="small" class="copy-button">{{$t('copy_link')}}</el-button>
                </div>
                <div class="invite-code-wrapper">
                  <span class="invite-code pointer" @click="copyHandle(item.invitationCode)">
                    {{$t('invite_code')}}: {{item.invitationCode }}
                    <el-tooltip :content="$t('copy_content_to_clipboard')" placement="top">
                      <i class="iconfont icon-copy1 pointer"></i>
                    </el-tooltip>
                  </span>
                  <div class="qr-code-container pointer"  @click="openQrCodeDialog(item.qrCodeUrl)">
                    <el-tooltip :content="$t('view_qr_code')" placement="top">
                      <qr-code-icon></qr-code-icon>
                    </el-tooltip>
                    <el-button type="text" class="view-qr-button">{{$t('view_qr_code')}}</el-button>
                  </div>
                </div>
              </div>
              <div class="icon-right">
                 <div class="icon-wrapper pointer" v-if="item.modifyRuleFlag&&userInfo.addLevelFlag"  @click="editHandle(item)">
                   <el-tooltip :content="$t('edit_link_settings')" placement="top">
                     <edit-icon></edit-icon>
                   </el-tooltip>
                </div>
                <div class="icon-wrapper pointer"  v-else  @click="lookDirectRuleInfoHandle(item)">
                  <el-tooltip :content="$t('view_rebate_rules')" placement="top">
                    <eye-icon></eye-icon>
                  </el-tooltip>
                </div>
                <div class="icon-wrapper pointer"  v-if="item.linkList && item.linkList.length > 0"  @click="openEditLinksDialog(item, 'subib')">
                  <el-tooltip :content="$t('more_links')" placement="top">
                    <more-icon></more-icon>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <out-commission-dialog
      ref="outcommission"
      :remain-amount="statistics.remainAmount"
      :dialog-show="dialogShow"
      @close="dialogShow = false"
      @outCommission-success="outCommissionSuccess"
      @add-collection="addCollection"
    ></out-commission-dialog>
    <look-direct-rule-dialog
      :dialog-show="lookRuleDialogShow"
      :direct-rule-info="currentDirectRuleInfo"
      @close="closeLookDialog"
      :rule-list="partner.ruleList"

    ></look-direct-rule-dialog>
    <qr-code-dialog
      :dialog-show="qrCodeDialogShow"
      :qr-code-url="qrCodeDialogUrl"
      @close="qrCodeDialogShow = false"
    ></qr-code-dialog>
    <more-links-dialog
      :dialog-show="editLinksDialogShow"
      :link-list="currentEditLinks"
      :link-type="editLinksType"
      @close="closeEditLinksDialog"
    ></more-links-dialog>
    <add-sub-ib-rule-dialog
      :dialog-show="addRuleDialogShow"
      :template-list="templateList"
      @close="closeAddRuleDialog"
      @add-success="addSuccess"
    ></add-sub-ib-rule-dialog>
    <edit-sub-ib-rule-dialog
      :dialog-show="editRuleDialogShow"
      :current-sub-ib-info="currentSubIbInfo"
      :father-rule-data="myRuleData"
      :sub-rule-data="currentSubRuleData"
      @close="closeEditRuleDialog"
      @edit-suceess="editSuccess"
    ></edit-sub-ib-rule-dialog>

    <bank-info-edit-dialog
      :dialog-show="bankInfoDialogShow"
      @close="closeBankInfoHandel"
      @ajax-success="editBankInfoSuccess"
    ></bank-info-edit-dialog>

    <bar-info-edit-dialog
      :dialog-show="barInfoDialogShow"
      :channel-info="channelInfo"
      :bar-title="barTitle"
      @close="closeBarInfoHandel"
      @ajax-success="barInfoAjaxSuccess"
    ></bar-info-edit-dialog>
  </div>
</template>

<script>
import { toggleStockMaxAndValue } from "@/utils/common";
import { throttle } from "@/utils";
// 绑定收款信息的
import {getCustPayTypes} from '@/api/user.js';

import barInfoEditDialog from "@/components/myFiles/collection/barInfoEditDialog";

import bankInfoEditDialog from "@/components/myFiles/collection/bankInfoEditDialog"

import editSubIbRuleDialog from "@/components/agent/propagandas/editSubIbRuleDialog";
import addSubIbRuleDialog from "@/components/agent/propagandas/addSubIbRuleDialog";
import lookDirectRuleDialog from "@/components/agent/propagandas/lookDirectRuleDialog";
import moreLinksDialog from "@/components/agent/propagandas/moreLinksDialog";
import outCommissionDialog from "@/components/agent/outCommissionDialog";
import QrCodeIcon from "@/components/public/qrCodeIcon";
import EyeIcon from "@/components/public/eyeIcon";
import EditIcon from "@/components/public/editIcon";
import MoreIcon from "@/components/public/moreIcon";
import QrCodeDialog from "@/components/agent/propagandas/qrCodeDialog";
import { getPartnerCenterData, getUserDefinedGroupConfigList,addDirectGuestInvitationLinks, getDirectGuestInvitationLinks,editDirectGuestInvitationLinks,getPartnerInfo,queryTMerchantCommissionLevels,queryTMerchantCommissionLevelsRule } from '@/api/userCenter.js';
import { mapGetters, mapActions } from 'vuex';
import copy from 'copy-to-clipboard';
export default {
  name: "index",
  components:{
    outCommissionDialog,
    lookDirectRuleDialog,
    addSubIbRuleDialog,
    editSubIbRuleDialog,
    moreLinksDialog,

    bankInfoEditDialog,
    barInfoEditDialog,
    QrCodeIcon,
    EyeIcon,
    EditIcon,
    MoreIcon,
    QrCodeDialog,
  },
  data() {
    return {
      currency: 'USD',
      statistics:{
        remainAmount: '', //可出佣金额
        totalAmount: '',//佣金总额
        custNumber: '',// 客户数
        ibCustNumber: '',// ib数
        loginNumber: '',// 客户账户数
        equity: '',// 净值
        balance: '', //余额
        nowVolume: '',//当前手数
        totalVolume: '',// 累积手数

        subEquity: '', // 客户净值
        subBalance: '', // 客户余额
        subLots: '', // 交易量
      },
      partner:{
        ruleList: [],
      },
      guestInvitationLinks: [],
      dialogShow: false,

      subIbInfoList: null,

      // 防止重复打开编辑弹框的标志
      isEditing: false,
      // 防止重复打开查看规则弹框的标志
      isViewingRule: false,
      // 防止重复打开编辑链接弹框的标志
      isEditingLinks: false,

      lookRuleDialogShow: false,
      qrCodeDialogShow: false,
      qrCodeDialogUrl: '',
      currentDirectRuleInfo: {},
      
      editLinksDialogShow: false,
      currentEditLinks: [],
      editLinksType: 'guest',

      addRuleDialogShow: false,
      myRuleData: [],
      editRuleDialogShow: false,
      currentSubRuleData: [],
      currentSubIbInfo: {
        levelName: '',
        id: '',
      },

      channelType: 0,
      bankInfoDialogShow: false,
      barInfoDialogShow: false,
      usdtInfo: {},
      otcInfo: {},
    }
  },
  computed: {
    ...mapGetters(['userInfo','custPayTypes']),
    outBtnDisable(){
      return !this.statistics.remainAmount
    },
    templateList() {
      if (this.myRuleData.length) {
        let emptList = JSON.parse(JSON.stringify(this.myRuleData));
        for (let i = 0; i < emptList.length; i++) {
          for (let j = 0; j < emptList[i].symbolGroup.length; j++) {
            emptList[i].symbolGroup[j].value = '';
          }
        }
        return emptList;
      } else {
        return [];
      }
    },
    channelInfo(){
      if(this.channelType == 2){
        return this.usdtInfo;
      }else {
        return this.otcInfo;
      }
    },
    barTitle(){
      if(this.channelType == 2){
        return 'USDT';
      }else if(this.channelType == 3){
        return this.$t('withdraw365');
      }
    },
  },
  created(){
    this.getPartnerCenterData();
    this.getStatisticsData();
    this.getList();
    this.getIbLevels();
    this.getSelfCommission();
  },
  methods: {
    ...mapActions(['ensureCustPayTypes']),
    addSuccess(){
      this.getIbLevels();
      this.addRuleDialogShow = false;
    },
    addCollection(channelType){
      this.queryPayTypes(() => {
        this.channelType = channelType;
        if(this.channelType == 1){
          this.bankInfoDialogShow = true;
        }else {
          this.barInfoDialogShow = true;
        }
      });
    },
    // 绑定收款信息的
    queryPayTypes(callback) {
      if (this.custPayTypes) {
        this.processPayTypesData(this.custPayTypes);
        callback();
      } else {
        this.ensureCustPayTypes().then((data) => {
          this.processPayTypesData(data);
          callback();
        }).catch(() => {
          callback();
        });
      }
    },
    processPayTypesData(data) {
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].payTypeId == 5) {
            this.usdtInfo = data[i];
          }
          if (data[i].payTypeId == 6) {
            this.otcInfo = data[i];
          }
        }
      }
    },
    closeBankInfoHandel(){
      this.bankInfoDialogShow = false;
    },
    editBankInfoSuccess(){
      this.bankInfoDialogShow = false;
      this.updateCollectionInfo();
    },
    updateCollectionInfo(){
      let tochannel = this.$refs.outcommission.$refs.firststep;
      tochannel.getWithdrawList();
    },

    closeBarInfoHandel(){
      this.barInfoDialogShow = false;
    },
    barInfoAjaxSuccess(){
      this.barInfoDialogShow = false;
      this.updateCollectionInfo();
    },

    addSubLinkHandle: throttle(function() {
      this.addRuleDialogShow = true;
    }, 2000),
    editSuccess(){
      this.getIbLevels();
      this.editRuleDialogShow = false;
    },
    editHandle: throttle(function(item) {
      this.currentSubIbInfo = item;
      
      // 立即打开弹框，防止重复打开
      if (this.editRuleDialogShow) {
        return; // 如果弹框已经打开，直接返回
      }
      
      this.editRuleDialogShow = true; // 先打开弹框
      this.isEditing = true; // 标记开始编辑
      
      queryTMerchantCommissionLevelsRule({
        levelId: item.id,
      }).then((res) => {
        // 参考 merchantLinkForm.vue 中的实现，获取父级规则数据
        queryTMerchantCommissionLevelsRule({
          custId: this.userInfo.id,
        }).then((res2) => {
          // 合并规则数据，将父级的 max 值设置到子级规则中
          for (let i = 0; i < res.data.length; i++) {
            for (let j = 0; j < res.data[i].symbolGroup.length; j++) {
              // 设置父级规则的 max 值
              res.data[i].symbolGroup[j].max = res2.data[i].symbolGroup[j].max;
              
              // 处理 Stock 类型的特殊情况
              if(res.data[i].symbolGroup[j].name === 'Stock' || res.data[i].symbolGroup[j].name === 'Crypto'){
                if(res.data[i].symbolGroup[j].value != -1){
                  res.data[i].symbolGroup[j].value = parseInt(res.data[i].symbolGroup[j].value * 100);
                }
                if(res.data[i].symbolGroup[j].max != -1){
                  res.data[i].symbolGroup[j].max = parseInt(res.data[i].symbolGroup[j].max * 100);
                }
              }
            }
          }
          
          // 处理 Stock 和  Crypto类型的 max 和 value
          //toggleStockMaxAndValue(res.data);
          this.currentSubRuleData = res.data;
          this.isEditing = false; // 数据加载完成后重置编辑标志
        })
      }).catch(() => {
        this.isEditing = false; // 出错时也要重置标志
        this.editRuleDialogShow = false; // 出错时关闭弹框
      })
    }, 2000),
    lookDirectRuleInfoHandle: throttle(function(directRuleInfo) {
      // 如果正在查看规则中，直接返回
      if (this.isViewingRule) {
        return;
      }
      
      this.currentDirectRuleInfo = directRuleInfo;
      this.isViewingRule = true; // 标记开始查看
      this.lookRuleDialogShow = true;
      
      // 对话框关闭时重置标志（通过 closeLookDialog）
    }, 2000),
    closeLookDialog(){
      this.lookRuleDialogShow = false;
      this.isViewingRule = false; // 重置查看标志
    },
    openQrCodeDialog(qrCodeUrl){
      this.qrCodeDialogUrl = qrCodeUrl;
      this.qrCodeDialogShow = true;
    },
    closeAddRuleDialog(){
      this.addRuleDialogShow = false;
    },
    closeEditRuleDialog(){
      this.editRuleDialogShow = false;
      this.isEditing = false; // 重置编辑标志
    },
    openEditLinksDialog: throttle(function(item, type = 'guest') {
      if (this.isEditingLinks) {
        return;
      }
      
      this.currentEditLinks = item.linkList;
      this.editLinksType = type;
      this.editLinksDialogShow = true;
      this.isEditingLinks = true;
    }, 2000),
    closeEditLinksDialog(){
      this.editLinksDialogShow = false;
      this.isEditingLinks = false;
    },
    outCommissionSuccess(){
      this.getStatisticsData();
    },
    outHandle: throttle(function() {
      this.dialogShow = true;
    }, 2000),
    getSelfCommission(){
      queryTMerchantCommissionLevelsRule({
        custId: this.userInfo.id,
      }).then((res) => {
        toggleStockMaxAndValue(res.data)
        this.myRuleData = res.data;
      })
    },
    getPartnerCenterData(){
      let parmas ={
        custId : this.userInfo.id
      };
      this.loading = true;
      getPartnerCenterData(parmas).then((res) => {
        this.loading = false;
        toggleStockMaxAndValue(res.data.ruleList)
        this.partner = res.data;
      })
    },
    getStatisticsData(){
      let parmas ={
        custId : this.userInfo.id
      };
      getPartnerInfo(parmas).then((res) => {
        this.statistics = res.data[0];
      })
    },
    getList() {
      let parmas = {
        custInfo: this.userInfo.id
      };
      getDirectGuestInvitationLinks(parmas).then((res) => {
        this.guestInvitationLinks = res.data.custLinks;
        this.isCanAddLinks = !res.data.foreignConfig; // 0是关闭,1是开启, // 开启时不能创建自定义链接
      });
    },
    getIbLevels(){
      queryTMerchantCommissionLevels({
        custId:this.userInfo.id
      }).then((res) => {
        this.subIbInfoList = res.data;
      })
    },
    copyHandle: throttle(function(link) {
      copy(link);

      this.$message({
        type: 'success',
        message: this.$t('User.copySuccess')
      });
    }, 2000),
  },
}
</script>

<style lang="scss" scoped>
.propagandas {
  .data-total,
  .my-rule,
  .customer-link
  {
    background-color: #ffffff;
    border-radius: 10px;
    margin-bottom: 24px;
  }
  .customer-link{
    background-color: inherit;
  }
  .RuleTable-outer {
    overflow-x: auto;
  }

  .data-total {
    padding: 20px;
    .total-item {
      color: #5E5873;
      margin-bottom: 10px;
      .label {
        font-size: 14px;
        padding-bottom: 8px;
      }
      .data {
        font-size: 24px;
        font-weight: 500;
        &.special-data {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .outer-left-btn {
            margin-right: 10px;
          }
        }
      }
    }
  }

  .my-rule {
    .header {
      height: 54px;
      display: flex;
      padding: 10px 20px;
      justify-content: space-between;
      align-items: center;
      .title {
        font-weight: 600;
        font-size: 16px;
        color: #5E5873;
      }
      .tab-inner {
        margin-bottom: 0;
      }
    }
  }
  .customer-link {
    padding: 30px 20px;
    .link-group {
      margin-bottom: 30px;
     
    }
    .group-title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 8px;
    }
    
    .link-title {
      color: #5E5873;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: "PingFang SC";
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: 21px;
      margin-bottom: 10px;
    }

    .bg-box {
      margin-bottom: 10px;
      background-color: #ffffff;
      border: 1px solid #E5E5E5;
      padding: 10px 15px;
      overflow: hidden;
      border-radius: 6px;
      border-left: 4px solid #FE5924;
      background: #FFF;
      gap: 12px;
      padding: 16px 20px 16px 24px;
      .link-content {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        justify-content: space-between;
        .left-content {
            display: flex;
            align-items: center;
            flex-wrap: nowrap;
            flex: 1;
            min-width: 0;
            
            .icon-copy1{
              color: #FE5924;
            }
            .invite-code-wrapper {
              display: flex;
              align-items: center;
              gap: 15px;
            }
            .link-text-wrapper {
              display: flex;
              align-items: center;
              border-radius: 10px 40px 40px 10px;
              background: #F8F8F8;
              padding: 5px 15px;
              padding-right: 0px;
              margin-right: 15px;
              flex: 1;
              min-width: 0;
              max-width: 520px;
              .link-text {
                flex: 1;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 14px;
                color: #333333;
                margin-right: 15px;
                min-width: 0;
              }
            }
            .el-button {
              margin-right: 4px;
            }
            .copy-button {
              border-radius: 18px;
              background: #FE5924;
            }
            .view-qr-button {
              color: #626262;
              font-family: "PingFang SC";
              font-size: 14px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
            .invite-code {
              margin-right: 15px;
              font-size: 14px;
              color: #333333;
              border-radius: 18px;
              background: rgba(254, 89, 36, 0.04);
              padding: 5px 15px;
              i {
                margin-left: 5px;
              }
            }
            .qr-code-container {
              display: flex;
              align-items: center;
              margin-right: 15px;
              qr-code-icon {
                margin-left: 15px;
              }
            }
          }
        .icon-right {
          display: flex;
          align-items: center;
          .icon-wrapper {
            border-radius: 7px;
            border: 1px solid #EBE9F1;
            padding: 8px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
          }
          .icon-wrapper:first-child {
            margin-right: 15px;
          }
        }
        i {
          margin-left: 10px;
          font-size: 16px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
    .subib-group-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
    }
    
    /* 手机端布局 */
    @media screen and (max-width: 768px) {
      .left-content{
        padding: 16px 20px 16px 24px;
      }
      .link-title {
        padding-left: 20px;
      }
      .customer-link{
          padding: 0px;
      }
      .link-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
      }
      
      .link-content .left-content {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
      }
      
      .link-content .left-content .link-text-wrapper {
        width: 100%;
        display: block;
        margin-right: 0;
        max-width: 100%;
      }
      
      /* invite-code 和 qr-code-container 显示在一行 */
      .link-content .left-content .invite-code-wrapper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 10px;
        width: 100%;
        flex-wrap: wrap;
      }
      
      .link-content .left-content .invite-code {
        display: block;
        flex: 1;
        min-width: 0;
      }
      
      .link-content .left-content .qr-code-container {
        display: block;
        flex-shrink: 0;
      }
      
      .link-content .icon-right {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 10px;
      }
      .invite-code {
        margin-right: 0px !important;
        padding: 5px 5px !important;
      }
      .qr-code-container
      {
        margin-right: 0px !important;
      }
      .bg-box .el-button
      {
        margin-right: 0px !important;
      }

     .bg-box
      {
          border-left: 4px solid #FE5924;
          padding: 16px 8px 16px 8px;
      }
    }
  }
  /* 手机端布局 */
  @media screen and (max-width: 768px) {
    .customer-link{
        padding: 0px;
    }
  }
}
</style>
